// src/util/mvpSdk.js
// Minimal Sharetribe-like SDK stub so legacy FTW boot paths don't crash.
// We will remove these call sites later; this is just a bridge to get UI rendering.

const ok = (data = {}) => Promise.resolve({ data });

export const createMvpSdk = () => {
  return {
    // FTW boot often calls sdk.authInfo() to hydrate auth state
    authInfo: () =>
      ok({
        // shape varies; keep it simple and "not authenticated"
        isAnonymous: true,
        isAuthenticated: false,
        scopes: [],
      }),

    // Some code might call currentUser.show() on boot
    currentUser: {
      show: () => ok(null),
    },

    // Some flows call login/logout even if you won't use them
    login: () => Promise.reject(new Error('Login disabled in MVP')),
    logout: () => ok({}),

    // If any integration expects a generic `transactions` or `listings` namespace,
    // keep them present but disabled
    listings: {
      query: () => Promise.reject(new Error('Use /api/listings in MVP')),
      show: () => Promise.reject(new Error('Use /api/listings/:id in MVP')),
    },
  };
};